import React, {Fragment} from "react";
import Dropzone from "react-dropzone";
import PropTypes from "prop-types";
import ProgressBar from "../../shared/ProgressBar";



const FileUploadModal = props => {
    const onDrop = files => {
        const file = files[0];
        props.onUpload(file);
    };

    return (
      <Fragment>
        {props.loading ? (
          <ProgressBar
            completedPercentage={props.uploadPercent}
            filename={props.filename}
          />
            ) : (
              <div className="mt4 file-upload">
                <Dropzone
                  style={
                            /* override Dropzone's default styles */
                            {}
                        }
                  onDrop={onDrop}
                >
                  {({getRootProps, getInputProps}) => (
                    <div className="null-state-container" data-testid="upload-image" {...getRootProps()}>
                      <input {...getInputProps()} />
                      <img alt="drag and drop here" src="https://legacy-design-assets.s3.amazonaws.com/images/drag_drop_icon.png" />
                      <div className="inline ml2 text-left">
                        <h2>Drag &amp; drop an image</h2>
                        <p className="help-block">or click to upload an image from your computer</p>
                      </div>
                    </div>
                  )}
                </Dropzone>
              </div>
            )}
      </Fragment>
    );
};
FileUploadModal.propTypes = {
    onUpload: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    uploadPercent: PropTypes.number.isRequired,
    filename: PropTypes.string
};

FileUploadModal.defaultProps = {
    filename: null
};

export default FileUploadModal;
